module.exports = "/_next/static/images/fac063a890b4a494e17512df75f0a1fa-app-screenshots-xs@2x.jpg";